import { getStoredCityId } from "../_constants/selectedCity";

// The web counterpart of what the native app injects for mera-kaam events
// (city, ...). Platform/userId come from analytics-context's pushEvent.
export function getEventContext() {
  if (typeof window === "undefined") return {};
  return {
    page_path: window.location.pathname,
    city: getStoredCityId() ?? "not_selected",
  };
}
